import React from 'react';
import PropTypes from 'prop-types';
import Styled from 'styled-components';
import Theme from '../common/NekoTheme';

const WindowBase = Styled.div`
  margin: 20px;
  padding: 14px;
  background-color: white;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);

  > * + * {
    /* Base margin between child elements */
    margin-top: 14px;
  }
`;

const TitleBar = Styled(props => (
  props.children ? (
    <div className={props.className}>
      {props.children}
    </div>
  ) : null
))`
  background-color: ${Theme.blue};
  color: white;
`;

const StyledNekoWindow = props => (
  <WindowBase className='window'>
    <TitleBar>{props.title}</TitleBar>
    {props.children}
  </WindowBase>
);

const NekoWindow = (props) => {
  return (<StyledNekoWindow {...props} />);
}

NekoWindow.propTypes = {
  title: PropTypes.string
};
NekoWindow.defaultProps = {
  title: undefined
};

export { NekoWindow };
